var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-page",class:{
    'nav-open': _vm.$sidebar.showSidebar,
    'full-page--login-shell': _vm.isLoginShellRoute,
    'full-page--hub-sunset': _vm.isHubSunsetRoute,
  }},[_c('div',{staticClass:"wrapper wrapper-full-page",class:{ 'wrapper-full-page--hub-sunset': _vm.isHubSunsetRoute },on:{"click":_vm.onWrapperClick}},[(!_vm.isHubSunsetRoute)?_c('notifications'):_vm._e(),_c('div',{staticClass:"page-header header-filter",class:[
        _vm.setPageClass,
        {
          'header-filter--login-shell': _vm.isLoginShellRoute,
          'clear-filter': _vm.isLoginShellRoute,
        },
      ],style:(_vm.isLoginShellRoute ? {} : _vm.setBgImage),attrs:{"filter-color":"black"}},[_c('div',{class:_vm.isLoginShellRoute ? 'login-shell-container' : 'container md-offset'},[_c('zoom-center-transition',{attrs:{"duration":_vm.pageTransitionDuration,"mode":"out-in"}},[_c('router-view')],1)],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }